export default "__VITE_ASSET__CDd6ljZ2__"